import { ButtonColor, useModal, ButtonVariant } from '@ampol/design-system';

export default function useConfirmExitModal({
  title,
  content,
  onConfirm,
  confirmLabel,
}) {
  const confirm = useModal({
    id: 'confirm-exit-modal',
    title: title,
    content: content,
    color: ButtonColor.Blue,
    actions: [
      {
        label: confirmLabel || 'Confirm and Exit',
        onClick: () => {
          onConfirm();
          confirm.close();
        },
        variant: ButtonVariant.Primary,
      },
      {
        label: 'Cancel',
        onClick: () => confirm.close(),
      },
    ],
    hideCloseButton: true,
  });
  return confirm;
}
